import { input } from '@b2b/types/core';
import angular, { INgModelController } from 'angular';

class PricingCheckboxController {
  static $inject = ['$element'];

  ngModel = input<boolean>();
  ngModelCtrl!: INgModelController;
  indeterminate = input<boolean>();

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-pricing-checkbox');
    this.$element.attr('tabindex', -1);
  }

  toggle() {
    this.ngModelChange();
  }

  ngModelChange() {
    this.ngModelCtrl.$setViewValue(this.ngModel);
  }
}

export const PricingCheckboxModule = angular
  .module('acme.view.application.membership.pricing.discounts.component.pricing-checkbox', ['ui.bootstrap'])
  .component('acmePricingCheckbox', {
    templateUrl: `views/application/views/membership/pricing/discounts/components/pricing-checkbox/pricing-checkbox.component.tpl.html`,
    controller: PricingCheckboxController,
    transclude: {},
    require: {
      ngModelCtrl: 'ngModel',
    },
    bindings: {
      ngModel: '<',
      indeterminate: '<',
    },
  }).name;
